import type * as React from 'react';
import { createContext, useContext } from 'react';

import type { SettingName } from '../editor-settings';
import { INITIAL_SETTINGS } from '../editor-settings';

type SettingsContextShape = {
  settings: Record<SettingName, boolean>;
};

const Context: React.Context<SettingsContextShape> = createContext({
  settings: INITIAL_SETTINGS,
});

export const useSettings = (): SettingsContextShape => {
  return useContext(Context);
};
